import { type RejectOrderCancelInput, rejectOrderCancelInputSchema } from '@repo/api-contracts';
import { useId, useState } from 'react';
import { formStyles, Label, OrderActionDialog } from '@/shared/ui';

interface OrderRejectDialogProps {
  readonly requestId: string;
  readonly actionable?: boolean;
  readonly onSubmit: (input: RejectOrderCancelInput) => Promise<unknown>;
  readonly onReload: () => void;
  readonly onClose: () => void;
  readonly pending?: boolean;
}

/** 요청 반려 — 고객이 취소 요청을 거둔 경우에만 쓴다. 연 요청이 더 이상 처리 중이 아니면 입력을 남긴 채 반려를 막는다. */
export function OrderRejectDialog({
  requestId,
  actionable = true,
  onSubmit,
  onReload,
  onClose,
  pending,
}: OrderRejectDialogProps) {
  const id = useId();
  const [reason, setReason] = useState('');
  return (
    <OrderActionDialog
      title="요청 반려"
      submitLabel="반려 처리"
      onReload={onReload}
      onClose={onClose}
      pending={pending}
      submitDisabled={!actionable}
      validate={() =>
        rejectOrderCancelInputSchema.safeParse({ requestId, reason }).success
          ? null
          : '반려 사유 1~500자를 입력해 주세요.'
      }
      onSubmit={async () => {
        await onSubmit({ requestId, reason: reason.trim() });
      }}
    >
      <p className={formStyles.hint}>반려는 고객이 요청을 거둔 경우에만 사용합니다.</p>
      {!actionable && (
        <p role="status" className={formStyles.notice}>
          열어 둔 취소 요청은 더 이상 반려할 수 없습니다. 최신 요청을 확인하고 창을 다시 열어
          주세요.
        </p>
      )}
      <div className={formStyles.field}>
        <Label htmlFor={`${id}-reason`}>반려 사유</Label>
        <textarea
          id={`${id}-reason`}
          className={formStyles.textarea}
          value={reason}
          onChange={(event) => setReason(event.target.value)}
        />
      </div>
    </OrderActionDialog>
  );
}
